import { platform } from '~/lib/params'
import { cn } from '~/lib/utils'

const SPINNER_BARS = 12

export function Spinner(props: { class?: string }) {
  return platform === 'ios' ? (
    <IosSpinner class={props.class} />
  ) : (
    <AndroidSpinner class={props.class} />
  )
}

function IosSpinner(props: { class?: string }) {
  return (
    <div class={cn('relative size-10', props.class)}>
      {Array.from({ length: SPINNER_BARS }, (_, i) => (
        <span
          class="absolute left-1/2 top-1/2 animate-spin-fade rounded-full"
          style={{
            width: '11%',
            height: '26%',
            'margin-left': '-5.5%',
            'margin-top': '-13%',
            background: 'rgb(93, 202, 165)',
            'transform-origin': 'center bottom',
            transform: `rotate(${i * 30}deg) translateY(-80%)`,
            'animation-delay': `${-(1 - i / SPINNER_BARS)}s`,
          }}
        />
      ))}
    </div>
  )
}

function AndroidSpinner(props: { class?: string }) {
  return (
    <svg
      class={cn('size-10 animate-spinner-rotate', props.class)}
      viewBox="0 0 50 50"
    >
      <circle
        class="animate-spinner-dash"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#5DCAA5"
        stroke-width="4"
        stroke-linecap="round"
        stroke-dasharray="1,150"
        stroke-dashoffset="0"
      />
    </svg>
  )
}
